import React from "react";
import { toast } from "react-toastify";
import apiAgent from "../../app/api/apiAgent";

export class UserIntegrationBox extends React.Component {
  state = {
    userID: this.props.userID,
    loading: false,
  };

  constructor(props) {
    super(props);
  }

  getStateData = () => {
    return this.state;
  };

  handleChange = (e) => {
    //console.log("inside User Integration Box handleChange, e:", e.target.value);
    this.setState({
      [e.target.name]: e.target.value,
    });
  };

  handleEmailIntegrationType = (e) => {
    var EmailIntegrationType = 1;
    if (e.target.value == "on" && e.target.id == "rbtnIMAPIntegration") {
      EmailIntegrationType = 2;
    }

    this.setState({
      EmailIntegrationType: EmailIntegrationType,
    });
  };

  handleTestSettings = (e) => {
    if (this.doValidate()) {
      this.setState({ loading: true });

      apiAgent.Setting.checkIMAPSettingAjax(this.props.UserIMAP)
        .then((response) => {
          toast.info("Your IMAP settings looks good");
        })
        .catch((error) => {
          toast.info("Unable to connect using your IMAP settings");
        })
        .finally(() => {
          this.setState({ loading: false });
        });
    }
  };

  doValidate = () => {
    var RegEmail = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,10})+$/;
    var failed = false;

    if (!this.state.Username.trim()) {
      toast.info("Please enter username");
      failed = true;
    }

    if (!this.state.Username.trim() || RegEmail.test(this.state.Username) == false) {
      toast.info("Username should be valid email address");
      failed = true;
    }

    if (!this.state.Password.trim()) {
      toast.info("Please enter password");
      failed = true;
    }

    if (!this.state.Server.trim()) {
      toast.info("Please enter server");
      failed = true;
    }

    if (!this.state.Port.trim()) {
      toast.info("Please enter port");
      failed = true;
    }

    return !failed;
  };

  handleCopyToClipboard = (text) => {
    navigator.clipboard.writeText(text);
    toast.info("Copied the text: " + text);
  };

  render() {
    return (
      <div>
        <div className="row">
          <div className="col-md-12">
            <div className="form-group">
              <h5>
                <b>Email Integration</b>
              </h5>
              <p>Automatically import all your portal listing leads to Base by setting up email forwarding from your email client.</p>
            </div>
          </div>
          <div className="col-md-12">
            <div className="form-group">
              <p>
                Your unique and secure email forwarding address: <b>{this.state.userID}@entegral.us</b>&nbsp;
                <i style={{ cursor: "pointer" }} className="fa fa-copy" onClick={() => this.handleCopyToClipboard(this.state.userID + "@entegral.us")}></i>
                <br />
                <a href="https://help.entegral.net/en/articles/5193968-configure-email-integration" target="_blank">
                  Click here
                </a>{" "}
                for help in setting this up in your email client.
              </p>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
